export default __webpack_public_path__ + "static/media/learose5-2048w.8e3cf189.webp";